import { render, staticRenderFns } from "./TextSlideContent.vue?vue&type=template&id=1c7c2743&scoped=true&"
import script from "./TextSlideContent.vue?vue&type=script&lang=js&"
export * from "./TextSlideContent.vue?vue&type=script&lang=js&"
import style0 from "./TextSlideContent.vue?vue&type=style&index=0&id=1c7c2743&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7c2743",
  null
  
)

export default component.exports